'use client';

import { c as _c } from "react/compiler-runtime";
import type { useFundingInlineCheckout } from '@morfi/onramp-sdk/react';
import type { MoonPayWebProvider } from '@morfi/onramp-sdk/web';
import type { ReactNode } from 'react';
import { FundingLoading } from '../shared/funding-loading';
import { FundingCardReview } from './funding-card-review';
import { FundingProviderFrame } from './funding-provider-frame';
import { FundingHostedReview } from './hosted/funding-hosted-review';
interface Props {
  checkout: ReturnType<typeof useFundingInlineCheckout>;
  provider: MoonPayWebProvider;
}
export function FundingPaymentReview(t0) {
  const $ = _c(15);
  const {
    checkout,
    provider
  } = t0;
  let t1;
  if ($[0] !== checkout) {
    t1 = checkout.method === "sepa" && checkout.state === "review" ? <FundingHostedReview checkout={checkout} /> : null;
    $[0] = checkout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== checkout) {
    t2 = checkout.method === "card" && checkout.state === "review" ? <FundingCardReview checkout={checkout} /> : null;
    $[2] = checkout;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== checkout.method || $[5] !== checkout.state) {
    t3 = checkout.method === "card" && checkout.state === "payment" ? <FundingLoading /> : null;
    $[4] = checkout.method;
    $[5] = checkout.state;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== checkout || $[8] !== provider) {
    t4 = (checkout.method === "card" || checkout.method === "sepa") && checkout.paymentSignature && checkout.attemptId ? <div hidden={checkout.method === "card" || checkout.state !== "payment"} aria-hidden={checkout.method === "card" || checkout.state !== "payment"}><FundingProviderFrame key={checkout.attemptId} provider={provider} checkout={checkout} mode="payment" /></div> : null;
    $[7] = checkout;
    $[8] = provider;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <>{t1}{t2}{t3}{t4}</>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}